import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { InvitationProvider } from "@/context/InvitationContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Guests from "@/pages/Guests";
import Login from "@/pages/Login";
import { AuthCallback } from "@/pages/AuthCallback";

axios.defaults.withCredentials = true;

function Root() {
  // Handle the OAuth callback (session_id in URL fragment) before normal routing.
  if (window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/i/:slug" element={<Home />} />
        <Route path="/guests" element={<Guests />} />
        <Route path="/walimah" element={<Home />} />
        <Route path="/walimah/i/:slug" element={<Home />} />
        <Route path="/walimah/guests" element={<Guests />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <InvitationProvider>
          <Root />
          <Toaster position="top-center" richColors />
        </InvitationProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
